<template>
<div class="EstimationStep">
    <div class="container_box">
        <div class="content">
            <el-steps :active="stepValue" align-center>
                <el-step title="选择企业维度"></el-step>
                <el-step title="选择估值方法"></el-step>
                <el-step title="填写估值要素"></el-step>
                <el-step title="完成企业估值"></el-step>
            </el-steps>
        </div>
    </div>

    <StepOne @setStepValue="setStepValue" @setStepData="setStepData" v-show="stepValue === 0"></StepOne>
    <StepTwo @setStepValue="setStepValue" @setTypeValue="setTypeValue" v-show="stepValue === 1" ref="steptwocomponents"></StepTwo>
    <StepThree @setStepValue="setStepValue" @setResultData="setResultData" v-show="stepValue === 2" ref="stepthreecomponents"></StepThree>
    <StepFour @setStepValue="setStepValue" v-show="stepValue === 3" ref="stepfourcomponents"></StepFour>


    <!-- <div class="page-module btnlist">
        <el-button @click="bbbbbbb" type="primary" plain>上一步</el-button>
        <el-button @click="aaaaaaaaaa" type="primary">下一步</el-button>
    </div> -->
</div>
</template>

<script>
import "animate.css/animate.min.css"
import StepOne from 'views/gujing/equityTool/components/StepOne'
import StepTwo from 'views/gujing/equityTool/components/StepTwo'
import StepThree from 'views/gujing/equityTool/components/StepThree'
import StepFour from 'views/gujing/equityTool/components/StepFour'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'EstimationStep',
    data() {
        return {
            stepValue: 0
        }
    },
    // 路由离开提示
    beforeRouteLeave(to, from, next){// 当离开组件时，是否允许离开
        // console.log(this.stepValue)
        if (this.stepValue < 3) {
            this.$confirm('您当前正在进行企业估值，退出不会保留当前填写数据', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // 确定退出
                next()
            }).catch(() => {
                // 取消
            })
        } else {
            next()
        }
    },
    mounted() {},
    methods: {
        // 估值结果数据
        setResultData(data) {
            // console.log(data)
            this.$refs.stepfourcomponents.getResultData(data)
        },
        // 设置估值流程第三步 估值要素的表单类型
        setTypeValue(type) {
            this.$refs.stepthreecomponents.getTypeValue(type)
        },
        // 设置估值流程第二步 估值方法的数据选项
        setStepData(data, paramObj) {
            // console.log(paramObj)
            this.$refs.stepthreecomponents.setParamsValue(paramObj)
            this.$refs.steptwocomponents.getCardData(data)
        },
        // 设置估值流程的步骤
        setStepValue(val) {
            this.stepValue = val
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        StepOne,
        StepTwo,
        StepThree,
        StepFour
    }
}
</script>

<style lang="scss" type="text/scss">
.el-message-box__btns {
    text-align: center;
    margin-bottom: 20px;
}
.el-message-box .el-message-box__content {
    padding: 40px 0;
    padding-top: 30px;
    text-align: center;
    color: #F56C6C;
}
.EstimationStep {
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // background-color: rgb(208, 229, 250);
    padding-top: 64px;
    .container_box {
        .content {
            padding: 40px 0;
            width: 1200px;
            margin: 0 auto;
            .el-steps {
                margin: 0 auto;
                width: 900px;
                .el-step {
                    width: 225px;
                }
                .el-step__line-inner {
                    border-width: 2px!important;
                    border-color: #409EFF;
                }
                .el-step__line {
                    height: 4px;
                    top: 10px;
                }
                .el-step__line {
                    background-color: #EAEFF6;
                }
                .el-step__icon {
                    background-color: #EAEFF6;
                    border-color: #EAEFF6;
                }
                .el-step__icon-inner {
                    color: #FFF;
                    font-weight: normal;
                }
                .is-finish{
                    .el-step__line {
                        background-color:#409EFF;
                    }
                }
                .is-finish, .is-process {
                    color: #108EE9;
                    .el-step__icon {
                        background-color: #108EE9;
                        border-color: #108EE9;
                    }
                    .el-step__icon-inner {
                        color: #FFF;
                    }
                }
            }
        }
    }
    .btnlist {
        text-align: center;
        .el-button {
            width: 180px;
            height: 40px;
            border-radius: 6px;
            &~.el-button {
                margin-left: 30px;
            }
        }
    }
}
</style>